<template>
   <div class="sidebar-form"></div>
</template>
<script>

  import UserProfile from '@/components/UserProfile'

  export default {
    name: 'sidebar-form',
    components: {UserProfile}
  }
</script>



// WEBPACK FOOTER //
// src/components/SidebarForm.vue